<script setup lang="ts">
import MessageString from './MessageString.vue';

defineProps({
  messageDayCard: Array,
  cardOfDay: String
})
</script>

<template>
    <transition name="modal-fade">
    <div class="modal" @click.self="close">
        <div class="modal_inner">
            <img :src="cardOfDay" alt="">
            <MessageString v-for="message, index in messageDayCard" :key="index" :message="message"></MessageString>
        </div>
    </div>
    </transition>
</template>

<script lang="ts">

export default {
    name: 'ModalCardDay',
    methods: {
      close() {
        this.$emit('close');
      },
    },
}
</script>

<style scoped>
.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
}
.modal_inner {
    position: relative;
    width: 85%;
    height: 75%;
    overflow-x: scroll;
    background: #212121fa;
    padding: 25px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;

}

img {
    align-self: center;
    width: 100px;
    aspect-ratio: 2 / 3;
    object-fit: cover;
    margin-bottom: 20px;
}
.modal-fade-enter,
  .modal-fade-leave-active {
    opacity: 0;
    transition: opacity .5s ease

  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease
  }
</style>


